<template>
  <div class="sp-template">
    <div class="h-title">提货订单</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item v-if="queryForm.status==0||queryForm.status==-1" label="客户">
              <el-select v-model="queryForm.customerIds" clearable multiple  filterable placeholder="选择客户">
                <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
    <!--         <el-form-item label="渠道">
              <el-select v-model="queryForm.productIds" clearable multiple placeholder="选择渠道">
                <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item v-if="queryForm.status==1||queryForm.status==2" label="司机">
              <el-select v-model="queryForm.drivers" clearable multiple placeholder="选择司机">
                <el-option v-for="(d, i) in drivers" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>


            <el-form-item label="订单号">
              <el-input v-model.lazy="queryForm.orderId"  type="textarea" placeholder="订单号"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="仓库">
              <el-select v-model.lazy="queryForm.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <span v-if="queryForm.status!=2">
                <el-form-item label="开始日期">
                <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
                </el-form-item>
            </span>
            <span v-else>
                <el-form-item label="开始日期">
                <el-date-picker v-model.lazy="queryForm.completeStartTime" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                <el-date-picker v-model.lazy="queryForm.completeEndTime" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
                </el-form-item>
            </span>
            
          </el-row>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(40106)" size="small" type="primary" @click="searchTask()">搜索</el-button>
            <el-button v-if="in_configs(40106)" size="small" @click="reset()">清空</el-button>

            <el-button v-if="queryForm.status==2" size="small" class="btn-cyan" @click="exportOrders()">导出</el-button>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="theStatus" @tab-click="searchTask">
					<el-tab-pane v-if="in_configs(40103)" label="待处理" name="0"></el-tab-pane>
                    <el-tab-pane v-if="in_configs(40103)" label="已审核" name="0.5"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40104)" label="派单中" name="1"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40106)" label="已完成" name="2"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40105)" label="异常" name="-1"></el-tab-pane>
				</el-tabs>
        <div class="button-groups">
          <el-button size="small" v-if ="theStatus==0" @click="createPickUpOrder">新建提货订单</el-button>
          <el-button size="small" v-if ="theStatus==0.5" @click="pickUpTaskClick">创建提货任务</el-button>
          <!-- <el-button size="small" @click="customizeDialogVisible = true">自定义列表显示项</el-button> -->
        </div>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%" max-height="800" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="订单号" width="140"  v-if="isOrder&&customizeShowColumns.id"></el-table-column>
        <el-table-column prop="pickUpId" label="提货单号" width="140"  v-if="!isOrder&&customizeShowColumns.pickUpId"></el-table-column>
        <el-table-column  label="订单号" width="160"    v-if="!isOrder">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.orderIds" :key="index">
                {{item.orderId}} 
            </div>
          </template>
        </el-table-column>

       <el-table-column v-if="queryForm.status==2" label="预约箱数" width="160"    >
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.orderIds" :key="index">
                {{item.totalCarton}} 
            </div>
          </template>
        </el-table-column>

        <el-table-column v-if="queryForm.status==2" label="实际箱数" width="160"    >
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.orderIds" :key="index">
                {{item.actualCarton}} 
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orgOwnerName" label="客户"    v-if="isOrder&&customizeShowColumns.orgOwnerName"></el-table-column>
        <el-table-column label="仓库"    v-if="customizeShowColumns.warehousCode">
          <template slot-scope="scope">
            {{warehouseMap[scope.row.warehouseCode]}}
          </template>
        </el-table-column>
       <!--  <el-table-column prop="productName" label="渠道"    v-if="customizeShowColumns.productName"></el-table-column> -->
     <!--    <el-table-column prop="contractName" label="联系人"    v-if="customizeShowColumns.contractName">
        </el-table-column> -->
      
        <el-table-column prop="totalCarton" label="货物箱数"    v-if="isOrder"></el-table-column>
        <el-table-column prop="actualTotalCarton" label="提货箱数"    v-if="queryForm.status==-1"></el-table-column>
        <el-table-column prop="totalWeight" label="货物重量(kg)"    v-if="isOrder&&queryForm.status!=-1"></el-table-column>
        <el-table-column prop="totalVolume" label="货物体积(m3)"    v-if="isOrder&&queryForm.status!=-1"></el-table-column>
        <el-table-column prop="remark" label="备注"  v-if="isOrder&&(queryForm.status==-1||queryForm.status==0)"></el-table-column>
        <el-table-column prop="imgs" label="图片" width="150px"  v-if="isOrder&&queryForm.status==-1">
           <template slot-scope="scope">
            <div class="img-container">
              <div v-for="(item,index) in scope.row.imgs" :key="index">
                <img :src='item' @click="previewImg(item)" />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="contact" label="联系人"    >
        </el-table-column>
        <el-table-column prop="phone" label="联系方式"    >
        </el-table-column>
        <el-table-column  label="取件地址"    v-if="customizeShowColumns.address">
           <template slot-scope="scope">
            <span >{{scope.row.province}} {{scope.row.city}} {{scope.row.address}}</span>
           </template>
        </el-table-column>
        <el-table-column prop="pickUpAt" label="预约提货时间" width="160"    v-if="customizeShowColumns.date"></el-table-column>

        <el-table-column prop="competeAt" label="完成提货时间" width="160"    v-if="queryForm.status==2||queryForm.status==-1"></el-table-column>
        <el-table-column  label="提货司机" width="80"    v-if="queryForm.status==2||queryForm.status==-1||queryForm.status==1">
           <template slot-scope="scope">
            <span >{{driversMap[scope.row.pickUpDriver]}}</span>
           </template>
        </el-table-column>
        <el-table-column  label="提货车辆" width="80"    v-if="queryForm.status==2||queryForm.status==-1||queryForm.status==1">
           <template slot-scope="scope">
            <span >{{vehiclesMap[scope.row.pickUpCar]}}</span>
           </template>
        </el-table-column>

        <el-table-column prop="auditor" label="审核人" width="80"    v-if="theStatus=='0.5'"></el-table-column>
        

       <!--  <el-table-column prop="createAt" label="下单时间" width="160"    v-if="isOrder&&customizeShowColumns.date"></el-table-column> -->

        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="queryForm.status==2&&!scope.row.havaAddress" type="text" size="small" @click="taskAddressEdit(scope.row)">编辑</el-button>
            <el-button v-if="queryForm.status==0 || queryForm.status==1" type="text" size="small" @click="addressEdit(scope.row)">编辑</el-button>

            <el-button v-if="queryForm.status==0 || queryForm.status==1" type="text" size="small" @click="deleteOrder(scope.row)">删除</el-button>
            <el-button v-if="queryForm.status==0 && theStatus==0" type="text" size="small" @click="auditOrder(scope.row)">审核</el-button>
            <el-button v-if="queryForm.status==1" type="text" size="small" @click="doneTask(scope.row)">完成</el-button>
            <el-button v-if="queryForm.status==-1" type="text" size="small" @click="handlingException(scope.row)">异常处理</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

    </el-card>

    <!-- Form -->
    <el-dialog title="完成" :visible.sync="dialogFormVisible" width="400px">
      <el-form size="small">
        <el-form-item label="提货箱数">
          <el-input v-model="cartonQty" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitDone()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="完成" :visible.sync="dialogTaskDoneVisible" width="400px">
      <el-form size="small">

        <div v-for="(item,index) in pickDoneOrderIds" :key="index">
          <div>  订单号: {{item.orderId}}</div>
          <el-form-item label="提货箱数">
          <el-input v-model="item.totalCarton" auto-complete="off"></el-input>
        </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogTaskDoneVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitTaskDone()">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="新建提货订单" :visible.sync="dialogCreatePickUpVisible" width="400px">
      <el-form size="small">
        <el-form-item label="订单号">
         <el-input v-model.lazy="newPickupOrder.id"  type="text" placeholder="订单号"></el-input>
        </el-form-item>
        <el-form-item label="提货时间">
          <el-date-picker v-model.lazy="newPickupOrder.pickUpTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="提货时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="联系人">
         <el-input v-model.lazy="newPickupOrder.contact"  type="text" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
         <el-input v-model.lazy="newPickupOrder.phone"  type="text" placeholder="联系方式"></el-input>
        </el-form-item>
        <el-form-item label="省份">
         <el-input v-model.lazy="newPickupOrder.province"  type="text" placeholder="省份"></el-input>
        </el-form-item>
        <el-form-item label="城市">
         <el-input v-model.lazy="newPickupOrder.city"  type="text" placeholder="城市"></el-input>
        </el-form-item>
        <el-form-item label="地址">
         <el-input v-model.lazy="newPickupOrder.address"  type="text" placeholder="地址"></el-input>
        </el-form-item>
        <el-form-item label="备注">
         <el-input v-model="newPickupOrder.remarks"  ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="canleCreatePickUp()">取 消</el-button>
        <el-button size="small" type="primary" @click="createPickUpSubmit()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="dialogTaskEditPickUpVisible" width="400px">
      <el-form size="small">
        <el-form-item label="联系人">
         <el-input v-model.lazy="editPickUpOrder.contact"  ></el-input>
        </el-form-item>

        <el-form-item label="联系电话">
         <el-input v-model.lazy="editPickUpOrder.phone"  ></el-input>
        </el-form-item>

          <el-form-item label="省份">
         <el-input v-model.lazy="editPickUpOrder.province"  ></el-input>
        </el-form-item>

        <el-form-item label="城市">
         <el-input v-model.lazy="editPickUpOrder.city"  ></el-input>
        </el-form-item>

          <el-form-item label="地址">
         <el-input v-model.lazy="editPickUpOrder.address"  ></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="canleTaskEditPickUp()">取 消</el-button>
        <el-button size="small" type="primary" @click="editTaskPickUpSubmit()">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog title="编辑" :visible.sync="dialogEditPickUpVisible" width="400px">
      <el-form size="small">

        <el-form-item label="总箱数">
         <el-input v-model.lazy="editPickUpOrder.totalCarton"  ></el-input>
        </el-form-item>

        <el-form-item label="总重量">
         <el-input v-model.lazy="editPickUpOrder.totalWeight"  ></el-input>
        </el-form-item>

        <el-form-item label="总体积">
         <el-input v-model.lazy="editPickUpOrder.totalVolume"  ></el-input>
        </el-form-item>

        <el-form-item label="联系人">
         <el-input v-model.lazy="editPickUpOrder.contact"  ></el-input>
        </el-form-item>

        <el-form-item label="联系电话">
         <el-input v-model.lazy="editPickUpOrder.phone"  ></el-input>
        </el-form-item>

          <el-form-item label="省份">
         <el-input v-model.lazy="editPickUpOrder.province"  ></el-input>
        </el-form-item>

        <el-form-item label="城市">
         <el-input v-model.lazy="editPickUpOrder.city"  ></el-input>
        </el-form-item>

          <el-form-item label="地址">
         <el-input v-model.lazy="editPickUpOrder.address"  ></el-input>
        </el-form-item>

         <el-form-item label="预约提货时间">
         <el-date-picker v-model="editPickUpOrder.pickUpTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="预约提货时间" style="width:200px;"></el-date-picker>
        </el-form-item>

        <el-form-item label="备注">
         <el-input v-model="editPickUpOrder.remarks"  ></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="canleEditPickUp()">取 消</el-button>
        <el-button size="small" type="primary" @click="editPickUpSubmit()">确 定</el-button>
      </div>
    </el-dialog>


    <el-dialog :title="queryForm.status==0 ? '创建提货订单' : '编辑' " :visible.sync="pickUpTaskVisible" width="400px">
      <el-form size="small">
        <el-form-item label="提货车辆">

           <el-select  v-model="pickUpTask.pickUpCar" placeholder="提货车辆">
              <el-option :label="item.name" :value="item.id" v-for="(item, index) in vehicles" :key="index"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item label="提货司机">

           <el-select   v-model="pickUpTask.pickUpDriver" placeholder="提货司机">
              <el-option :label="item.name" :value="item.id" v-for="(item, index) in drivers" :key="index"></el-option>
            </el-select>
        </el-form-item>

        <!-- <el-form-item label="提货时间">
          <el-date-picker v-model="pickUpTask.pickUpTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期"></el-date-picker>
        </el-form-item> -->

        <el-form-item label="备注" v-if="queryForm.status==0" >
          <!-- <el-input v-model="pickUpTask.remark" auto-complete="off"></el-input> -->
          
                <span v-html="pickUpTask.remark"></span>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="pickUpTaskVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="pickUpTaskSumbmit()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看大图" :visible.sync="previewImgVisible">
      <img :src="prieviewImgSrc" alt="" style="max-width:100%">
    </el-dialog>

    <!-- 自定义列表展示项 -->
		<customize-colums
			:tablename = "tablename"
			:customizeDialogVisible = "customizeDialogVisible"
			:customizeShowColumns = "customizeShowColumns"
			@selectedColumns = "selectedColumns"
			@closeCustomizeDialog = "closeCustomizeDialog">
		</customize-colums>
  </div>

</template>

<script>
import customizeColums from "../../components/customize-columns.vue";
export default {
  data() {
    return {
      previewImgVisible: false,
      prieviewImgSrc: "",
      warehouses:[],
      warehouseMap: {},
      pickDoneOrderIds:[
        {
          orderId:'123456',
          totalCarton:''
        }
      ],
      newPickupOrder:{
        pickUpTime:'',
        id:'',
        contact:'',
        phone:'',
        province:'',
        city:'',
        address:''
      },
      queryForm: {
        warehouseIds: [],
        orderId: "",
        status: "0",
        customerIds: [],
        productIds: [],
        drivers:[],
        startDate: "",
        endDate: "",
        export: 0,
        audited: false,
        completeStartTime: "",
	    completeEndTime: ""
      },
      theStatus: '0',
     //havaAddress:false,
      dialogTaskDoneVisible:false,
      dialogEditPickUpVisible:false,
      dialogTaskEditPickUpVisible:false,
      pickUpOrderIds:'',
      pickUpTask:{
          orderIds:[],
          remark:'',
          pickUpCar:'',
          pickUpDriver:'',
          pickUpTime:'',
          id: ''
      },
      taskDoneVo:{
          taskId:'',
          orders:[]
      },
      editPickUpOrder:{
          orderId:'',
          totalCarton:'',
          totalWeight:'',
          totalVolume:'',
          contact:'',
          phone:'',
          province:'',
          city:'',
          address:'',
          pickUpTime: '',
          remarks: ''
      },
      pickUpTaskVisible:false,
      dialogCreatePickUpVisible:false,
      tablename: "提货订单",
      customizeDialogVisible: false,
      multipleSelection: [],
      customizeShowColumns: {
        id: true,
        pickUpId:true,
        orgOwnerName: true,
        warehousCode: true,
        productName: true,
        contractName: true,
        phone: false,
        totalCarton: true,
        totalWeight: true,
        totalVolume: true,
        address: true,
        vehicle: true,
        driver: true,
        date: true
      },
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},
      tableData: [],
      drivers: [],
      vehicles: [],
      driversMap: {},
      vehiclesMap: {},
      dialogFormVisible: false,
      cartonQty: 0,
      orderId: "",

      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      isOrder:true,
      currentPage: 1 //当前页
    };
  },
  components: {
    customizeColums
  },
  created() {
    if (localStorage.getItem("customizeTmsOpPickUpColumns")) {
      let customizeTmsOpPickUpColumns = JSON.parse(
        localStorage.getItem("customizeTmsOpPickUpColumns")
      );
      this._initCustomizeTmsOpPickUpColumns(customizeTmsOpPickUpColumns);
    }
    setTimeout(() => {
      this.findAllChannle();
      this.findByCustomerName();
      
      this.queryDriver();
      this.queryVehicles();
      // 仓库加载后加载订单
      this.queryWarehouseList();

    }, 1000)
  },
  computed: {
    configs() {
      return JSON.parse(sessionStorage.configs);
    }
  },
  methods: {
    previewImg(src) {
      if(!src || src == '') {
        return
      }
      this.previewImgVisible = true
      this.prieviewImgSrc = src
    },
    handlingException(row){
      let _this = this
      console.log("a")
        this.$request1
            ({
              method: 'PUT',
              url: '/pick-up-order/handlingException/' + row.id + '',
              withCredentials: true
            })
            .then(function(res) {
              if (res.data.success) {
                _this.$notify({
                  title: "提示",
                  message: "操作成功"
                });
              } else {
                _this.$notify({
                  title: "提示",
                  message: res.data.message,
                  type: "error",
                  duration: 0
                });
              }
               _this.searchTask()
            })
            .catch(function(error) {
              console.log(error);
            });
      
    },
    submitTaskDone(){
         let _this = this
         this.dialogTaskDoneVisible = false;

         let checkoutTotalCarton = true;

         this.pickDoneOrderIds.forEach((d,i) => {
            if(!d.totalCarton||d.totalCarton<0){
                 _this.$notify({
                  title: "提示",
                  message: "提货箱数不能为空",
                  type: "error",
                  duration: 0
                });
                checkoutTotalCarton = false;
                throw '提货箱数不能为空';
            }
          });


          if(checkoutTotalCarton){
           this.$request1
            ({
              method: 'POST',
              url: '/pick-up-task/done',
              data:this.pickDoneOrderIds,
              withCredentials: true
            })
            .then(function(res) {
              if (res.data.success) {
                _this.$notify({
                  title: "提示",
                  message: "操作成功"
                });
              } else {
                _this.$notify({
                  title: "提示",
                  message: res.data.message,
                  type: "error",
                  duration: 0
                });
              }
               _this.searchTask()
            })
            .catch(function(error) {
              console.log(error);
            });
          }

        
    },
    doneTask(row){
      this.dialogTaskDoneVisible = true;
      this.pickDoneOrderIds = []
      //this.pickDoneOrderIds = row.orderIds
      row.orderIds.forEach((d,i) => {
        let taskOrderCarton = {
          orderId:d.orderId,
          totalCarton:''
        }
        this.pickDoneOrderIds.push(taskOrderCarton)
      });
    },
    canleCreatePickUp(){
      this.pickUpOrderIds = ''
      this.dialogCreatePickUpVisible = false;
    },

    createPickUpReset(){
      this.newPickupOrder = {
         pickUpTime:'',
          id:'',
          contact:'',
        phone:'',
        province:'',
        city:'',
        address:''
      }
    },

    createPickUpSubmit(){
        let orderIds = [];
        let _this = this
        this.pickUpOrderIds.split(/\n+/gim).forEach((d, i) => {
          if (d && d != "") {
              orderIds.push(d);
           }
        })
        this.pickUpOrderIds = ''
        this.dialogCreatePickUpVisible = false;

        if(!this.newPickupOrder.pickUpTime){
             _this.$notify({
                  title: "提示",
                  message: "提货时间不能为空",
                  type: "error",
                  duration: 0
                });
                return;
        }

        if(!this.newPickupOrder.contact){
             _this.$notify({
                  title: "提示",
                  message: "联系人不能为空",
                  type: "error",
                  duration: 0
                });
                 return;
        }

        if(!this.newPickupOrder.phone){
             _this.$notify({
                  title: "提示",
                  message: "联系电话不能为空",
                  type: "error",
                  duration: 0
                });
                 return;
        }

        if(!this.newPickupOrder.province){
             _this.$notify({
                  title: "提示",
                  message: "省份不能为空",
                  type: "error",
                  duration: 0
                });
                 return;
        }

        if(!this.newPickupOrder.city){
             _this.$notify({
                  title: "提示",
                  message: "城市不能为空",
                  type: "error",
                  duration: 0
                });
                 return;
        }

        if(!this.newPickupOrder.address){
             _this.$notify({
                  title: "提示",
                  message: "地址不能为空",
                  type: "error",
                  duration: 0
                });
                 return;
        }


        this.$request1
            ({
              method: 'POST',
              url: '/pick-up-order/add',
              data:this.newPickupOrder
              ,
              withCredentials: true,
              headers: {
                    "content-type": "application/json"
              }
            })
            .then(function(res) {
              _this.createPickUpReset()
              if (res.data.success) {
                _this.$notify({
                  title: "提示",
                  message: "新增成功"
                });
              } else {
                _this.$notify({
                  title: "提示",
                  message: res.data.message,
                  type: "error",
                  duration: 0
                });
              }
               _this.searchTask()
            })
            .catch(function(error) {
              console.log(error);
            });


    },

    createPickUpOrder(){
      this.dialogCreatePickUpVisible = true;
    },

    deleteOrder(row){
        let _this = this
        let type = "order";
        let id = row.id;

        let tip = '此操作将删除该订单，请仔细核对。';
        if(this.queryForm.status==1){
            tip = '此操作将删除该任务，请仔细核对。';
            type = "task";
            id = row.pickUpId;
        }


       this.$confirm(tip, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1
            ({
              method: 'POST',
              url: '/pick-up-order/DELETE',
              data: {
                    id: id,
                    type: type
              },
              withCredentials: true,
              headers: {
                    "content-type": "application/json"
              }
            })
            .then(function(res) {
              //console.log(res);
              if (res.data.success) {
                _this.$notify({
                  title: "提示",
                  message: "删除成功",
                  type: 'success'
                });
                _this.searchTask()
              } else {
                _this.$notify({
                  title: "提示",
                  message: res.data.message,
                  type: "error",
                  duration: 0
                });
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });


    },
    auditOrder(row){
        let _this = this
       this.$confirm("是否审核通过", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1
            ({
              method: "post",
              url: '/pick-up-order/audit/' + row.id + '',
            })
            .then(function(res) {
              //console.log(res);
              if (res.data.success) {
                _this.$notify({
                  title: "提示",
                  type: "success",
                  message: "success"
                });
                _this.queryOrder();
              } else {
                _this.$notify({
                  title: "提示",
                  message: res.data.message,
                  type: "error",
                  duration: 0
                });
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    pickUpTaskClick(){
      if(this.multipleSelection.length == 0) {
        this.$message({
          message: '请选择需要分配的订单',
          type: 'warning'
        });
        return
      }
      let _this = this;

        this.pickUpTask = {
          orderIds:[],
          remark:'',
          pickUpCar:'',
          pickUpDriver:'',
          pickUpTime:'',
          id: ''
      };      
      this.pickUpTask.remark = '';
      this.multipleSelection.forEach((item, index) => {
        //   console.log(9999999);
        //   console.log(item);
          _this.pickUpTask.orderIds.push(item.id)
            if(item.remark!=null){
                _this.pickUpTask.remark += item.remark + ';';
            }
          
      })
      this.pickUpTaskVisible = true;
    },
    pickUpTaskSumbmit(){
      var _this = this;
      this.$request1
        .post(
          '/pick-up-task',
          _this.pickUpTask,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          _this.resetPickUpTastDailog()
          if (response.data.success) {
            _this.$message({
              message: "操作成功",
              type: "success"
            });
          }else{
            _this.$message.error(response.data.message);
          }
           _this.searchTask()
        });
    },
    resetPickUpTastDailog(){
      this.pickUpTaskVisible = false;
      this.pickUpTask.orderIds = []
      this.pickUpTask.remark = ''
      this.pickUpTask.pickUpCar = ''
      this.pickUpTask.pickUpDriver = ''
      this.pickUpTask.pickUpTime = ''
    },
    taskAddressEdit(row){
      this.dialogTaskEditPickUpVisible = true;
      this.editPickUpOrder = {
          pickUpId:row.pickUpId,
          orderId:row.id,
          totalCarton:row.totalCarton,
          totalWeight:row.totalWeight,
          totalVolume:row.totalVolume,
          contact:row.contact,
          phone:row.phone,
          province:row.province,
          city:row.city,
          address:row.address,
          pickUpTime: this.formatterDate2(row.pickUpTime),
          remarks: row.remarks
      }
    },
    addressEdit(row){
        // console.log(25555);
        // console.log(row);
        if(this.queryForm.status==0){
            this.dialogEditPickUpVisible = true;
            this.editPickUpOrder = {
                orderId:row.id,
                totalCarton:row.totalCarton,
                totalWeight:row.totalWeight,
                totalVolume:row.totalVolume,
                contact:row.contact,
                phone:row.phone,
                province:row.province,
                city:row.city,
                address:row.address,
                pickUpTime:this.formatterDate2(row.pickUpTime),
                remarks: row.remarks
            }
        }else if(this.queryForm.status==1){

            this.pickUpTask = {
                orderIds:[],
                remark:'',
                pickUpCar: row.pickUpCar,
                pickUpDriver: row.pickUpDriver,
                pickUpTime:'',
                id: row.pickUpId
            }
            this.pickUpTaskVisible = true;
        }
      
    },
    canleEditPickUp(){
      this.dialogEditPickUpVisible = false;
    },

    canleTaskEditPickUp(){
      this.dialogTaskEditPickUpVisible = false;
    },

    editTaskPickUpSubmit(){
      let _this = this
      this.dialogTaskEditPickUpVisible = false;
      this.$request1
        .post(
          '/pick-up-task/address',
          this.editPickUpOrder,
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.data.success) {
            _this.$message({
              message: "保存成功",
              type: "success"
            });
          }
          _this.searchTask()
        });
    },

    editPickUpSubmit(){
      let _this = this
      this.dialogEditPickUpVisible = false;
      
        this.$request1({
            url: '/pick-up-order/address',
            method: "post",
            data: this.editPickUpOrder,
            withCredentials: true,
            headers: { "Content-Type": "application/json" }
        })
        .then(function(response) {
          if (response.data.success) {
            _this.$message({
              message: "保存成功",
              type: "success"
            });
          }
          _this.searchTask()
        });

    },
    // 接收自定义列表显示项组件的数据并关闭弹层
    closeCustomizeDialog(val) {
      this.customizeDialogVisible = val;
    },
    // 接收自定义列表显示项组件的数据并赋值给customizeShowColumns对象
    selectedColumns(val) {
      this._initCustomizeTmsOpPickUpColumns(val);
      this.customizeDialogVisible = false;
    },
    // 给自定义列表项的对象赋值
    _initCustomizeTmsOpPickUpColumns(val) {
      for(var key in val) {
        this.customizeShowColumns[key] = val[key]
      }
    },

      //多选按钮
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.disabledDetainGoodsBtn = true;
      this.disabledreleaseGoodsBtn = true;
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        this.multipleSelection.forEach((d, i) => {
          if (d.detainGoods) {
            this.disabledreleaseGoodsBtn = false;
          } else {
            this.disabledDetainGoodsBtn = false;
          }
        });
      }
    },
    reset() {
      this.queryForm = {
        warehouseIds: [],
        orderId: "",
        status: "0",
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      }
      this.searchTask()
    },
      queryWarehouseList(){
        let _this = this;
        _this.$request1
        .get(
          '/warehouse/staff',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          // console.log(res);
          _this.warehouses = res.data;
          _this.warehouses.forEach(a => {
                _this.warehouseMap[a.id] = a.name;
            });
            
            _this.queryOrder();
        })
        .catch(function(error) {
          console.log(error);
        });
        
    },
    //查询渠道
    findAllChannle() {
      let _this = this;
      this.$request1
        .get(
          '/system/channel/all',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          _this.channels = res.data;
          if (_this.channels.length > 0) {
            _this.channels.forEach(c => {
              _this.channelsMaps[c.id] = c.name;
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //查询客户
    findByCustomerName() {
      let _this = this;
      this.$request1
        .get(
          '/customerAll',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.customers = res.data.data;
            if (_this.customers.length > 0) {
              _this.customers.forEach(c => {
                _this.customerMaps[c.id] = c.name;
              });
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //搜索
    searchTask() {
        let _this = this;
        this.queryForm.status = this.theStatus;
        this.isOrder = false;
      if(this.theStatus==0){
          this.isOrder = true;
          this.queryForm.audited = false;
      }else if (this.theStatus==0.5){      
          this.isOrder = true;   
         this.queryForm.audited = true;
         this.queryForm.status = 0;
      }else if(this.theStatus==-1){
            this.isOrder = true;
          this.queryForm.audited = null;
      }
      this.currentPage = 1;
      this.queryOrder();
      //console.log("搜索");
    },
    //编辑
    handleEdit(index, row) {
      row.assign = false;
      //console.log(index, row);
    },
    //保存司机车辆
    handleSave(index, row) {
      let _this = this;
      if (!row.driver.id || !row.vehicle.id) {
        this.$message.error("车辆或司机不能为空");
        return;
      }
      row.assign = true;
      row.driver.name = this.driversMap[row.driver.id];
      row.vehicle.name = this.vehiclesMap[row.vehicle.id];

      this.$request1
        .post(
          '/driver-task',
          {
            driverId: row.driver.id,
            vehicleId: row.vehicle.id,
            orderId: row.id
          },
          {
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          if (response.data.success) {
            _this.$message({
              message: "保存成功",
              type: "success"
            });
          }
        });
    },
    //分页
    handleSizeChange(val) {
        this.pageSize = val;
      this.currentPage = 1;
      this.queryOrder();
      //console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.queryOrder();

    },
    queryOrder() {
      let _this = this;

      //过滤仓库
        let wlist = [];
        if(this.warehouses!=null && this.warehouses.length>0){
            if(_this.queryForm.warehouseIds && _this.queryForm.warehouseIds.length>0){
                wlist = _this.queryForm.warehouseIds;
            }else{
                wlist = this.warehouses.map(a => a.id);
            }
        }else{
            wlist.push("NOT MATCHING");
        }

        let orderIds = [];
        _this.queryForm.orderId.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          orderIds.push(d);
        }
      });

      let formdata = {
        orderIds: orderIds,
        refNumbers: _this.queryForm.refNumbers,
        drivers: _this.queryForm.drivers,
        customerIds: _this.queryForm.customerIds,
        productIds: _this.queryForm.productIds,
        status: _this.queryForm.status,
        startDate: _this.queryForm.startDate,
        endDate: _this.queryForm.endDate,
        currentPage: _this.currentPage,
        pageSize: _this.pageSize,
        warehouseIds: wlist,
        audited: _this.queryForm.audited,
        completeStartTime: _this.queryForm.completeStartTime,
        completeEndTime: _this.queryForm.completeEndTime
      };

      this.$request1
        .post(
          '/pick-up-order/query',
          formdata,
          {
            timeout: 10000,
            withCredentials: true,
            // headers: {
            //   "content-type": "application/x-www-form-urlencoded"
            // }
          }
        )
        .then(function(response) {
          _this.tableData = response.data.data;
          _this.total = response.data.total;
          //console.log('_this.tableData' +JSON.stringify( _this.tableData))
          _this.tableData.forEach((v, i) => {
            _this.$set(v,"edit",false)
            v.createAt = _this.formatDate(
              new Date(v.createAt),
              "yyyy-MM-dd HH:mm:ss"
            );
            v.pickUpAt = _this.formatDate(
              new Date(v.pickUpTime),
              "yyyy-MM-dd HH:mm:ss"
            );
            v.competeAt = ''
            if(v.competeTime){
              v.competeAt = _this.formatDate(
                new Date(v.competeTime),
                "yyyy-MM-dd HH:mm:ss"
              );
            }
            if (!v.driver) {
              v.driver = {};
            }
            v.havaAddress = true;
            if(!v.contact){
              v.havaAddress = false;
            }
            if (!v.vehicle) {
              v.vehicle = {};
            }
          });
        })
        .catch(function(error) {
          //console.log(error);
        });
    },

    exportOrders(){

        let _this = this;

      //过滤仓库
        let wlist = [];
        if(this.warehouses!=null && this.warehouses.length>0){
            if(_this.queryForm.warehouseIds && _this.queryForm.warehouseIds.length>0){
                wlist = _this.queryForm.warehouseIds;
            }else{
                wlist = this.warehouses.map(a => a.id);
            }
        }else{
            wlist.push("NOT MATCHING");
        }

        let orderIds = [];
        _this.queryForm.orderId.split(/\n+/gim).forEach((d, i) => {
        if (d && d != "") {
          orderIds.push(d);
        }
      });

      let submitForm = {
        orderIds: orderIds,
        refNumbers: _this.queryForm.refNumbers,
        drivers: _this.queryForm.drivers,
        customerIds: _this.queryForm.customerIds,
        productIds: _this.queryForm.productIds,
        status: _this.queryForm.status,
        startDate: _this.queryForm.startDate,
        endDate: _this.queryForm.endDate,
        currentPage: _this.currentPage,
        pageSize: _this.pageSize,
        warehouseIds: wlist,
        audited: _this.queryForm.audited,
        completeStartTime: _this.queryForm.completeStartTime,
        completeEndTime: _this.queryForm.completeEndTime
      };

      

    //    _this.multipleSelection.forEach(a => {
    //       submitForm.orderIds.push(a.id);
    //     });


      var url = tmsSpringUrl + '/pick-up-order/export';

      var form = document.createElement("form");
      form.method = "post";
      form.action = url;
      form.target = "_blank";
      document.body.appendChild(form);

      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "data";
      input.value = JSON.stringify(submitForm);
      form.appendChild(input);

      var input2 = document.createElement("input");
      input2.type = "hidden";
      input2.name = "token";
      input2.value = this.$getToken()
      form.appendChild(input2);
      
      form.submit();

    },
    queryDriver() {
      let _this = this;

      this.$request1
        .get(
          '/all-drivers',
          {
            timeout: 10000,
            withCredentials: true,
            headers: {
              "content-type": "application/x-www-form-urlencoded"
            }
          }
        )
        .then(function(response) {
          _this.drivers = response.data.data;
          for (let index = 0; index < _this.drivers.length; index++) {
            _this.driversMap[_this.drivers[index].id] =
              _this.drivers[index].name;
          }
          //console.log( _this.drivers);
          //console.log( _this.driversMap);
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    queryVehicles() {
      let _this = this;

      this.$request1
        .get(
          '/all-vehicles',
          {
            timeout: 10000,
            withCredentials: true,
            headers: {
              "content-type": "application/x-www-form-urlencoded"
            }
          }
        )
        .then(function(response) {
          _this.vehicles = response.data.data;
          for (let index = 0; index < _this.vehicles.length; index++) {
            _this.vehiclesMap[_this.vehicles[index].id] =
              _this.vehicles[index].name;
          }
          //console.log( _this.vehiclesMap);
          //console.log(response);
        })
        .catch(function(error) {
          //console.log(error);
        });
    },
    taskDone(row) {
      if (!row.assign) {
        this.$message({
          type: "error",
          message: "请选择司机和车辆！"
        });
        return;
      }
      this.dialogFormVisible = true;
      this.cartonQty = row.totalCarton;
      this.orderId = row.id;
    },
    submitDone() {
      let _this = this;
      if (_this.cartonQty <= 0) {
        this.$message.error("请填写正确的数量");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$request1
        .post(
          '/pick-up-order',
          {
            qty: _this.cartonQty,
            orderId: _this.orderId
          },
          {
            timeout: 30000,
            withCredentials: true,
            headers: {
              "content-type": "application/json"
            }
          }
        )
        .then(function(response) {
          loading.close();
          if (response.data.success) {
            _this.$message({
              message: "提交成功",
              type: "success"
            });
            _this.dialogFormVisible = false;
            for (let index = 0; index < _this.tableData.length; index++) {
              if (_this.tableData[index].id == _this.orderId) {
                _this.tableData.splice(index, 1);
                break;
              }
            }
            _this.tableData;
          } else {
            _this.$message.error("提交失败：" + response.data.message);
          }
        })
        .catch(function(error) {
          loading.close();
        });
    },
    formatterDate2(date) {
        
      //return new Date(row.createAt).toLocaleString();
      if(date==null || date==''){
          return '';
      }
      
      return this.formatDate(new Date(date), "yyyy-MM-dd HH:mm:ss");
    },
    formatDate(date, fmt) {
      if (!date) {
        return "";
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, //小时
        "H+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      var week = {
        "0": "/u65e5",
        "1": "/u4e00",
        "2": "/u4e8c",
        "3": "/u4e09",
        "4": "/u56db",
        "5": "/u4e94",
        "6": "/u516d"
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      if (/(E+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (RegExp.$1.length > 1
            ? RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468"
            : "") + week[date.getDay() + ""]
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    }
  }
};
//function formatDate(date,fmt){if(!date){return""}var o={"M+":date.getMonth()+1,"d+":date.getDate(),"h+":date.getHours()%12==0?12:date.getHours()%12,"H+":date.getHours(),"m+":date.getMinutes(),"s+":date.getSeconds(),"q+":Math.floor((date.getMonth()+3)/3),"S":date.getMilliseconds()};var week={"0":"/u65e5","1":"/u4e00","2":"/u4e8c","3":"/u4e09","4":"/u56db","5":"/u4e94","6":"/u516d"};if(/(y+)/.test(fmt)){fmt=fmt.replace(RegExp.$1,(date.getFullYear()+"").substr(4-RegExp.$1.length))}if(/(E+)/.test(fmt)){fmt=fmt.replace(RegExp.$1,((RegExp.$1.length>1)?(RegExp.$1.length>2?"/u661f/u671f":"/u5468"):"")+week[date.getDay()+""])}for(var k in o){if(new RegExp("("+k+")").test(fmt)){fmt=fmt.replace(RegExp.$1,(RegExp.$1.length==1)?(o[k]):(("00"+o[k]).substr((""+o[k]).length)))}}return fmt};
</script>

<style lang="scss" scoped>
.img-container{
  display: flex;
  >:first-child{
    margin-right: 15px;
  }
  img{
    max-width: 60px;
    &:hover{
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/pickupgoods.vue